/**
 * /admin — historique des statuts d'un dépôt ou d'une demande (2026-10-16).
 *
 * La première étape (le dépôt) vient de `created_at` ; les suivantes de la
 * table `historique_statuts`, tenue depuis la migration 043. Un dossier
 * d'avant n'a pas de chemin enregistré : on montre alors son statut courant et
 * sa date, sans inventer les étapes intermédiaires.
 */
import React from 'react';

// Les dates du serveur sont en UTC sans fuseau : sans le « Z », le navigateur
// les lirait en heure locale, deux heures trop tôt l'été.
export const quand = (iso) => (iso
  ? new Date(iso.endsWith('Z') ? iso : `${iso}Z`).toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit',
  })
  : '—');

export default function AdminHistorique({ dossier, libelles, depot = 'Déposé' }) {
  const etapes = dossier.historique || [];
  const avantHistorique = etapes.length === 0 && dossier.statut_at;

  return (
    <details className="zk-adm-historique">
      <summary>Historique du statut{etapes.length > 0 ? ` · ${etapes.length + 1} étapes` : ''}</summary>
      <ol>
        <li><b>{depot}</b> <small>{quand(dossier.created_at)}</small></li>
        {etapes.map((e) => (
          <li key={`${e.cree_le}-${e.vers}`}>
            <b>{libelles[e.vers] || e.vers}</b> <small>{quand(e.cree_le)}{e.par ? ` · ${e.par}` : ''}</small>
            {e.texte && <q>{e.texte}</q>}
          </li>
        ))}
        {avantHistorique && (
          <li>
            <b>{libelles[dossier.statut] || dossier.statut}</b> <small>{quand(dossier.statut_at)}</small>
            <em>étapes intermédiaires non enregistrées (avant le 16/10/2026)</em>
          </li>
        )}
      </ol>
    </details>
  );
}
